import React, { useEffect, useState } from 'react'
import styles from './style/configuration_favorite_style.module.scss'
import LocalizedLink from '../../../global/LocalizedLink'
import ConfigurationCard from '../configuration-card/ConfigurationCard'
import NewConfigurationCallToAction from '../new-configuration-call-to-action/NewConfigurationCallToAction'
import Spinner from '../../../global/Spinner'
import Pagination from '../../../global/pagination/Pagination'
import Translation from '../../../global/Translation'
import { ReactComponent as IconInfo } from '../../../../assets/img/icons/icon-catalog-info.svg'

const ConfigurationFavorite = (props) => {
    const { favoriteConfigurations, fetchFavoriteConfigurations, isLoading } = props
    const [pageFavoriteConfig, setPageFavoriteConfig] = useState(0)
    const [sizeFavoriteConfig] = useState(15)

    useEffect(() => {
        fetchFavoriteConfigurations(pageFavoriteConfig, sizeFavoriteConfig)
    }, [pageFavoriteConfig, sizeFavoriteConfig])

    const items = favoriteConfigurations && favoriteConfigurations.content && favoriteConfigurations.content.length > 0 ? favoriteConfigurations.content : []
    const totalPages = favoriteConfigurations && favoriteConfigurations.totalPages ? favoriteConfigurations.totalPages : 0
    const currentPage = favoriteConfigurations && favoriteConfigurations.currentPage ? favoriteConfigurations.currentPage : 0

    return (
        <div className={styles['favorite-page'] + ' container mt-4'}>
            {isLoading ? (
                <Spinner isLoading={isLoading} />
            ) : (
                <React.Fragment>
                    {/* Back */}
                    <div className={styles['favorite-page__back']}>
                        <LocalizedLink routeId="ROUTE_CUT_TO_SIZE" queryString="" params={{ outlet: '' }} gtmLabel="saved-custom-products-drafts_link_back-to--custom-products">
                            <i className="fas fa-chevron-left" />
                            <span>
                                <Translation id={"back_select_elaborated_type"} defaultMessage={"Back to elaborated type selection"} />
                            </span>
                        </LocalizedLink>
                    </div>

                    {/* Header */}
                    <header className={styles['favorite-page__header']}>
                        <h1 className={styles['favorite-page__title']}>
                            <Translation id={"my_saved_configurations"} defaultMessage={"My saved configurations"} />
                        </h1>
                        <p className={styles['favorite-page__subtitle']}>
                            <Translation id="these_are_the_configurations_you_have_saved_you_can_continue_configuring" defaultMessage={"These are the configurations you have saved. You can continue configuring a product to purchase it, or you can duplicate an existing configuration so you don't lose it. You can also delete configurations you no longer need."} />
                        </p>

                        <div className={styles['favorite-page__header-info']}>
                            <div>
                                <IconInfo />
                            </div>
                            <div>
                                <span>
                                    <Translation id={"info_prices_favorite_configurations"} defaultMessage={"Please note that prices are updated when you resume the setup process based on current rates. Amounts may vary from the date you saved your configuration."} />
                                </span>
                                
                            </div>
                        </div>
                    </header>

                    {(!items || items.length === 0) ? (
                        <div className={styles['favorite-page__grid']}>
                            <div className={styles['favorite-page__empty'] || ''}>
                                <p>
                                    <Translation id={"you_do_not_have_any_saved_configurations_yet"} defaultMessage={"You do not have any saved configurations yet."} />
                                </p>
                            </div>
                            <NewConfigurationCallToAction />
                        </div>
                    ) : (
                        <div className={styles['favorite-page__grid']}>
                            {items.map(item => (
                                <ConfigurationCard key={item.grouped && item.parentRef ? item.parentRef : item.id} item={item} pageFavoriteConfig={pageFavoriteConfig} sizeFavoriteConfig={sizeFavoriteConfig} {...props}/>
                            ))}
                            <NewConfigurationCallToAction />
                        </div>
                    )}

                    <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={setPageFavoriteConfig} />
                </React.Fragment>
            )}
        </div>
    )
}

export default ConfigurationFavorite
